import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminMenu from '../components/AdminMenu';
import './AdminAmpliaciones.css';

function AdminAmpliaciones() {
  const [solicitudes, setSolicitudes] = useState([]);
  const [historial, setHistorial] = useState([]);
  const [mostrarHistorial, setMostrarHistorial] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [orden, setOrden] = useState({ campo: 'fecha', asc: false });
  const [pagina, setPagina] = useState(1);
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [loading, setLoading] = useState(false);

  const porPagina = 25;

  const cargarSolicitudes = async () => {
    try {
      const res = await axios.get('/api/ampliaciones/pendientes');
      setSolicitudes(res.data);
    } catch (error) {
      console.error('Error al cargar solicitudes:', error);
    }
  };

  const cargarHistorial = async () => {
    try {
      const res = await axios.get('/api/ampliaciones/historial');
      setHistorial(res.data);
    } catch (error) {
      console.error('Error al cargar historial:', error);
    }
  };

  useEffect(() => {
    cargarSolicitudes();
  }, []);

  const aceptar = async (id, user_id, meses, expiracion) => {
    try {
      setLoading(true);
      const response = await axios.post('/api/ampliaciones/aceptar', {
        id,
        user_id,
        meses,
        expiracionActual: expiracion
      });
      
      if (response.data.success) {
        alert('Ampliación aceptada y cuenta reactivada si era necesario');
      } else {
        alert('Ampliación aceptada pero hubo un problema al reactivar la cuenta');
      }
      
      cargarSolicitudes();
    } catch (error) {
      console.error('Error al aceptar:', error);
      alert('Error al procesar la solicitud');
    } finally {
      setLoading(false);
    }
  };

  const rechazar = async (id) => {
    try {
      setLoading(true);
      await axios.post('/api/ampliaciones/rechazar', { id });
      cargarSolicitudes();
    } catch (error) {
      console.error('Error al rechazar:', error);
      alert('Error al rechazar la solicitud');
    } finally {
      setLoading(false);
    }
  };

  const abrirHistorial = async () => {
    await cargarHistorial();
    setMostrarHistorial(true);
  };

  const cerrarHistorial = () => {
    setMostrarHistorial(false);
    setBusqueda('');
    setFechaDesde('');
    setFechaHasta('');
    setPagina(1);
  };

  const historialFiltrado = historial
    .filter(a => a.username.toLowerCase().includes(busqueda.toLowerCase()))
    .filter(a => {
      const fecha = new Date(a.created_at);
      const desde = fechaDesde ? new Date(fechaDesde) : null;
      const hasta = fechaHasta ? new Date(fechaHasta) : null;
      if (desde && fecha < desde) return false;
      if (hasta && fecha > hasta) return false;
      return true;
    })
    .sort((a, b) => {
      if (orden.campo === 'username') {
        return orden.asc
          ? a.username.localeCompare(b.username)
          : b.username.localeCompare(a.username);
      } else {
        return orden.asc
          ? new Date(a.created_at) - new Date(b.created_at)
          : new Date(b.created_at) - new Date(a.created_at);
      }
    });

  const totalPaginas = Math.ceil(historialFiltrado.length / porPagina);
  const historialPagina = historialFiltrado.slice((pagina - 1) * porPagina, pagina * porPagina);

  return (
    <>
      <AdminMenu />
      <div style={{ paddingTop: '60px' }}>
        <h2>Solicitudes de Ampliación</h2>
        <button onClick={abrirHistorial}>📜 Ver Historial</button>
        
        {loading && <div className="loading">Procesando...</div>}
        
        {solicitudes.length === 0 ? (
          <p>No hay solicitudes pendientes</p>
        ) : (
          <ul className="solicitudes-list">
            {solicitudes.map(s => (
              <li key={s.id} className="solicitud-item">
                <div className="solicitud-info">
                  <strong>{s.username}</strong> solicita <strong>{s.meses} mes{s.meses > 1 ? 'es' : ''}</strong><br />
                  Observaciones: <em>{s.observaciones || 'Ninguna'}</em><br />
                  Fecha actual: {new Date(s.expiracion).toLocaleDateString()}
                </div>
                <div className="solicitud-acciones">
                  <button 
                    onClick={() => aceptar(s.id, s.user_id, s.meses, s.expiracion)}
                    disabled={loading}
                  >
                    Aceptar
                  </button>
                  <button 
                    onClick={() => rechazar(s.id)}
                    disabled={loading}
                  >
                    Rechazar
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}

        {mostrarHistorial && (
          <div className="modal-overlay">
            <div className="modal-historial">
              <h3>Historial de Ampliaciones</h3>

              <div className="filtros-superiores">
                <input
                  type="text"
                  placeholder="Buscar por usuario..."
                  value={busqueda}
                  onChange={e => setBusqueda(e.target.value)}
                />
                <div className="fechas-filtro">
                  <label>Desde:</label>
                  <input
                    type="date"
                    value={fechaDesde}
                    onChange={e => setFechaDesde(e.target.value)}
                  />
                  <label>Hasta:</label>
                  <input
                    type="date"
                    value={fechaHasta}
                    onChange={e => setFechaHasta(e.target.value)}
                  />
                </div>
              </div>

              <div className="orden-controles">
                <button onClick={() => setOrden({ campo: 'created_at', asc: !orden.asc })}>
                  Fecha {orden.campo === 'created_at' && (orden.asc ? '↑' : '↓')}
                </button>
                <button onClick={() => setOrden({ campo: 'username', asc: !orden.asc })}>
                  Usuario {orden.campo === 'username' && (orden.asc ? '↑' : '↓')}
                </button>
                <button className="cerrar-btn" onClick={cerrarHistorial}>❌ Cerrar</button>
              </div>

              <ul className="historial-lista">
                {historialPagina.map(a => (
                  <li key={a.id} className={`historial-item ${a.estado}`}>
                    <div className="historial-header">
                      <strong>{a.username}</strong> - {new Date(a.created_at).toLocaleDateString()}
                      <span className={`estado-badge ${a.estado}`}>{a.estado}</span>
                    </div>
                    <div className="historial-details">
                      <span>{a.meses} mes{a.meses > 1 ? 'es' : ''}</span>
                      <span>Perfil: {a.perfil_nombre || '—'}</span>
                    </div>
                  </li>
                ))}
              </ul>

              <div className="paginacion">
                <button 
                  disabled={pagina === 1} 
                  onClick={() => setPagina(pagina - 1)}
                >
                  ⬅️ Anterior
                </button>
                <span>Página {pagina} de {totalPaginas}</span>
                <button 
                  disabled={pagina === totalPaginas} 
                  onClick={() => setPagina(pagina + 1)}
                >
                  Siguiente ➡️
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default AdminAmpliaciones;